import React, { useState, useEffect, Fragment } from 'react';
import {
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';

// Icons
import EditIcon from "@material-ui/icons/Edit";
import translation from "../../../i18n/i18.json"
import useStyles from "./VendorBlockExcemption.css"
import AllActions from '../../../actions';
import { MasterDataService } from '../../../services/MasterDataService';
import { InActiveVendorObj } from '../../../models/Master/InActiveVendor';
import { useHistory, useLocation } from "react-router-dom";
import BlockExcemptionPopUp from '../../../components/Vendor/Popup/BlockExcemptionDialog';
import {
  InforDisplyaDuration,
  MasterDataConstants,
  VendorForm1Modes,
  NavigationPaths,
  AutoBlockStatus
} from "../../../constants/AppConstants";
export default function VendorBlockExcemption() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const initialState: InActiveVendorObj = {
    id: 0,
    name: "",
    vendorcode: "",
    vendorname: "",
    purchasingorganization: "",
    bulkorsample: "",
    vendorcategory: "",
    rmsubcategory: "",
    financecategory: "",
    reasonforonboarding: "",
    autoblockscheduledate: "",
    companycode: "",
    autoBlockStatus: "",
    autoBlockStatusId: 0

  };
  let rowsPerPage = MasterDataConstants.TablerowCount;
  const [page, setPage] = React.useState(0);
  const [rowCount, setRowCount] = React.useState(0);
  const [isTableLoading, setIsTableLoading] = React.useState(false);
  const [filterVendorCode, setFilterVendorCode] = React.useState("");
  const [filterVendorName, setFilterVendorName] = React.useState("");
  let [tableRowData, setTableRowData] = useState<InActiveVendorObj[]>([]);
  let [updatedTableData, setUpdatedTableData] = useState<InActiveVendorObj[]>([]);
  const [detailData, setDetailData] = useState<InActiveVendorObj[]>([]);
  const [openRequestChange, setOpenRequestChange] = useState(false);
  const [requestchangeTitle, setRequestchangeTitle] = useState("");
  const [vendorObj, setVendorObj] = useState<InActiveVendorObj>()
  const tableColumnData = [
    { name: translation.vendor_excemption_vendorcode },
    { name: translation.vendor_excemption_vendorname },
    { name: translation.vendor_excemption_purchasing_organization },
    { name: translation.vendor_excemption_companycode },
    { name: translation.vendor_excemption_samplebulk },
    { name: translation.vendor_excemption_vendorcategory },
    { name: translation.vendor_excemption_rmsubcategory },
    { name: translation.vendor_excemption_financecategory },
    { name: translation.vendor_excemption_reasonforonboarding },
    { name: translation.vendor_excemption_autoblockscheduledate },
    { name: translation.vendor_excemption_status },
  ];

  const prepareForRequest = () => {
    dispatch(AllActions.backDropActions.openBackDrop());
  };

  const compeleteRequest = (success: boolean, message?: string) => {
    dispatch(AllActions.backDropActions.closeBackDrop());
    if (message) {
      if (success) {
        dispatch(
          AllActions.infoActions.openInforSuccess(
            message,
            InforDisplyaDuration.common
          )
        );
      } else {
        dispatch(
          AllActions.infoActions.openInforError(
            message,
            InforDisplyaDuration.common
          )
        );
      }
    }
  };
  const getInActiveVendorList = () => {
    prepareForRequest();
    MasterDataService.getInActiveVendorList(
      function (responeData: InActiveVendorObj[]) {
        const indexOfLastItem = (page + 1) * rowsPerPage;
        const indexOfFirstItem = indexOfLastItem - rowsPerPage;
        const currentData = responeData.slice(indexOfFirstItem, indexOfLastItem);
        setTableRowData(currentData);
        setDetailData(responeData);
        setRowCount(responeData.length);
        compeleteRequest(true);
        setIsTableLoading(false);
        setUpdatedTableData(responeData);
      },
      function (error: Error) {
        setTableRowData([]);
        setDetailData([]);
        setFilterVendorName("");
        setFilterVendorCode("");
        compeleteRequest(false, translation.master_user_list_error);
        setIsTableLoading(false);
        updatedTableData = [];
      }
    );
  };

  const onUpdateConfirm = (e: any) => {
    getInActiveVendorList();
  };

  useEffect(() => {
    if (isTableLoading) {
      getInActiveVendorList();
      setFilterVendorName("");
      setFilterVendorCode("");
      rowsPerPage = MasterDataConstants.TablerowCount;
    }
  }, [isTableLoading]);

  useEffect(() => {
    setPage(0);
    setIsTableLoading(true);
    setFilterVendorName("");
    setFilterVendorCode("");
  }, []);


  const handleChangePage = (event: any, newPage: number) => {
    setPage(newPage);
    const indexOfLastItem = (newPage + 1) * rowsPerPage;
    const indexOfFirstItem = indexOfLastItem - rowsPerPage;
    var currentData = updatedTableData.slice(indexOfFirstItem, indexOfLastItem);
    setTableRowData(currentData);
  };


  const onExtendClick = (item: InActiveVendorObj) => {
    //setSelectedData(listItem);
    /*   history.push(NavigationPaths.VendorRequest, {
        mode: VendorForm1Modes.VendorBlockExcemption,
        sapVendorNo: item.vendorCode,
        companyCode: item.companyCode,
        poCodes: item.purchasingOrganization
      }); */
    prepareForRequest();
    compeleteRequest(true);
    setVendorObj(item);
    setRequestchangeTitle(translation.vendorchangepopup_block_excemption_title);
    setOpenRequestChange(true);
  };

  const handleRequestChangeClose = (e: any) => {
    setOpenRequestChange(false);
    setVendorObj(initialState);
  };

  const handleInputChange = (e: any, field: any) => {
    setUpdatedTableData(detailData);
    let updated = detailData;
    if (field == "vendorCode") {
      tableRowData = detailData;
      setFilterVendorCode(e.target.value);
      if (e.target.value == "" && filterVendorName == "") {
        setUpdatedTableData(detailData);
        setTableRowData(detailData);
        setRowCount(detailData.length);
        const indexOfLastItem = 1 * rowsPerPage;
        const indexOfFirstItem = indexOfLastItem - rowsPerPage;
        var currentData = detailData.slice(indexOfFirstItem, indexOfLastItem);
        setTableRowData(currentData);
        setPage(0);
      }
      if (e.target.value.length >= 3) {
        if (e.target.value != "" && filterVendorName == "") {
          updated = tableRowData.filter(row => row.vendorCode.toLowerCase().includes(e.target.value.toLowerCase()));
          setTableRowData(updated);
          setUpdatedTableData(updated);
        }
        else if (e.target.value == "" && filterVendorName == "") {
          updated = detailData;
          setTableRowData(updated);
          setUpdatedTableData(updated);
        }
        else if (e.target.value == "" && filterVendorName != "") {
          updated = tableRowData.filter(row => row.vendorName.toLowerCase().includes(filterVendorName.toLowerCase()));
          setTableRowData(updated);
          setUpdatedTableData(updated);
        }
        else if (e.target.value != "" && filterVendorName != "") {
          updated = tableRowData.filter(row => row.vendorCode.toLowerCase().includes(e.target.value.toLowerCase()) && row.vendorName.toLowerCase().includes(filterVendorName.toLowerCase()));
          setTableRowData(updated);
          setUpdatedTableData(updated);
        }
        setRowCount(updated.length);
        const indexOfLastItem = 1 * rowsPerPage;
        const indexOfFirstItem = indexOfLastItem - rowsPerPage;
        var currentData = updated.slice(indexOfFirstItem, indexOfLastItem);
        setTableRowData(currentData);
        setPage(0);
      }
      else {
        if (e.target.value == "" && filterVendorName != "") {
          updated = tableRowData.filter(row => row.vendorName.toLowerCase().includes(filterVendorName.toLowerCase()));
          setTableRowData(updated);
          setUpdatedTableData(updated);

          setRowCount(updated.length);
          const indexOfLastItem = 1 * rowsPerPage;
          const indexOfFirstItem = indexOfLastItem - rowsPerPage;
          var currentData = updated.slice(indexOfFirstItem, indexOfLastItem);
          setTableRowData(currentData);
          setPage(0);
        }
      }
    }
    else if (field == "vendorName") {
      tableRowData = detailData;
      setFilterVendorName(e.target.value);
      if (e.target.value == "" && filterVendorCode == "") {
        setUpdatedTableData(detailData);
        setTableRowData(detailData);
        setRowCount(detailData.length);
        const indexOfLastItem = 1 * rowsPerPage;
        const indexOfFirstItem = indexOfLastItem - rowsPerPage;
        var currentData = detailData.slice(indexOfFirstItem, indexOfLastItem);
        setTableRowData(currentData);
        setPage(0);
      }
      if (e.target.value.length >= 3) {
        if (e.target.value != "" && filterVendorCode == "") {
          updated = tableRowData.filter(row => row.vendorName.toLowerCase().includes(e.target.value.toLowerCase()));
          setTableRowData(updated);
          setUpdatedTableData(updated);
        }
        else if (e.target.value == "" && filterVendorCode == "") {
          updated = detailData;
          setTableRowData(updated);
          setUpdatedTableData(updated);
        }
        else if (e.target.value == "" && filterVendorCode != "") {
          updated = tableRowData.filter(row => row.vendorCode.toLowerCase().includes(filterVendorCode.toLowerCase()));
          setTableRowData(updated);
          setUpdatedTableData(updated);
        }
        else if (e.target.value != "" && filterVendorCode != "") {
          updated = tableRowData.filter(row => row.vendorName.toLowerCase().includes(e.target.value.toLowerCase()) && row.vendorCode.toLowerCase().includes(filterVendorCode.toLowerCase()));
          setTableRowData(updated);
          setUpdatedTableData(updated);
        }
        setRowCount(updated.length);
        const indexOfLastItem = 1 * rowsPerPage;
        const indexOfFirstItem = indexOfLastItem - rowsPerPage;
        var currentData = updated.slice(indexOfFirstItem, indexOfLastItem);
        setTableRowData(currentData);
        setPage(0);
      }
      else {
        if (e.target.value == "" && filterVendorCode != "") {
          updated = tableRowData.filter(row => row.vendorCode.toLowerCase().includes(filterVendorCode.toLowerCase()));
          setTableRowData(updated);
          setUpdatedTableData(updated);

          setRowCount(updated.length);
          const indexOfLastItem = 1 * rowsPerPage;
          const indexOfFirstItem = indexOfLastItem - rowsPerPage;
          var currentData = updated.slice(indexOfFirstItem, indexOfLastItem);
          setTableRowData(currentData);
          setPage(0);
        }
      }

    }
  };



  return (
    <React.Fragment>
      <Grid
        container
        spacing={2}
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        className={classes.createHeader}
      >
        <span className={classes.createHeaderTxt}>
          {translation.vendor_excemption_extendblocheader}
        </span>
      </Grid>
      <Grid
        container
        spacing={2}
        item
        xs={12}
        sm={12}
        md={1}
        lg={1}
        style={{ float: "right" }}
      >
      </Grid>
      <div className={classes.tblOuterBG}>
        <TableContainer className={classes.tblContainer}>
          <Table size="small" stickyHeader aria-label="sticky table">
            {/* <TableHead className={classes.tblHeader}>
             
            </TableHead> */}
            <TableHead className={classes.tblHeader}>
              <TableRow>
                {tableColumnData &&
                  tableColumnData.map((column, index) => {
                    return <TableCell>{column.name}</TableCell>;
                  })}
                <TableCell align="center" style={{ width: "165px" }}>
                  {translation.master_table_actions}
                </TableCell>
              </TableRow>
              <TableRow style={{ backgroundColor: "lightgrey" }}>
                <TableCell align="center">
                  <Grid
                    className={classes.inputWrapper_Search}
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                  >
                    <TextField
                      variant="outlined"
                      type="text"
                      value={filterVendorCode}
                      placeholder={translation.vendor_excemption_vendorcode}
                      onChange={(e) => handleInputChange(e, 'vendorCode')}
                      autoFocus
                    /></Grid>
                </TableCell>
                <TableCell align="center">
                  <Grid
                    className={classes.inputWrapper_Search}
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                  >
                    <TextField
                      variant="outlined"
                      type="text"
                      value={filterVendorName}
                      placeholder={translation.vendor_excemption_vendorname}
                      onChange={(e) => handleInputChange(e, 'vendorName')}
                      autoFocus
                    /></Grid>
                </TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody className={classes.tblBody}>
              {tableRowData &&
                tableRowData.map((row, index) => {
                  return (
                    <TableRow key={row.id}>
                      <TableCell>{row.vendorCode}</TableCell>
                      <TableCell>{row.vendorName}</TableCell>
                      <TableCell>{row.purchasingOrganization}</TableCell>
                      <TableCell>{row.companyCode}</TableCell>
                      <TableCell>{row.bulkOrSample}</TableCell>
                      <TableCell>{row.vendorCategory}</TableCell>
                      <TableCell>{row.rmSubCategory}</TableCell>
                      <TableCell>{row.financeCategory}</TableCell>
                      <TableCell>{row.reasonForOnboarding}</TableCell>
                      <TableCell>{row.autoBlockScheduleDate}</TableCell>
                      <TableCell>{row.autoBlockStatus}</TableCell>
                      {(row.autoBlockStatusId == AutoBlockStatus.PlannedToInActive || row.autoBlockStatusId == AutoBlockStatus.ExemptionRejected) && (
                        <TableCell align="center">
                          <div className={classes.editBtn}>
                            {<button onClick={(e) => onExtendClick(row)}>
                              <EditIcon></EditIcon>
                              <span className={classes.editBtnTxt}>
                                {translation.vendor_excemption_extendblockbtntxt}
                              </span>
                            </button>}
                          </div>

                        </TableCell>)}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[]}
          component="div"
          count={rowCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
        ></TablePagination>

        <BlockExcemptionPopUp
          open={openRequestChange}
          requestMode={VendorForm1Modes.VendorBlockExcemption}
          title={requestchangeTitle}
          id={vendorObj?.id || 0}
          vendorNo={vendorObj?.vendorCode}
          vendorCode={vendorObj?.vendorCode}
          vendorName={vendorObj?.vendorName}
          companyCode={vendorObj?.companyCode}
          poCodeList={vendorObj?.purchasingOrganization}
          bulkOrSample={vendorObj?.bulkOrSample}
          vendorCategory={vendorObj?.vendorCategory}
          rmsubCategory={vendorObj?.rmsubCategory}
          financeCategory={vendorObj?.financeCategory}
          reasonForOnboarding={vendorObj?.reasonForOnboarding}
          handleClose={handleRequestChangeClose}
          onUpdateConfirm={onUpdateConfirm}
        ></BlockExcemptionPopUp>
      </div>


    </React.Fragment>
  )
}